import React from 'react';
import { Nav } from 'react-bootstrap';
import { Link, useLocation } from 'react-router-dom';
import './Sidebar.css';

export const navItems = [
  { path: '/', icon: 'D', label: 'ダッシュボード' },
  { path: '/bookings', icon: 'B', label: '予約管理' },
  { path: '/ledger', icon: 'L', label: 'オーナー精算' },
  { path: '/accounting', icon: 'K', label: '決算資料' },
  { path: '/properties', icon: 'P', label: '物件管理' },
  { path: '/emails', icon: 'M', label: 'メール管理' },
  { path: '/templates', icon: 'T', label: '案内文テンプレート' },
  { path: '/settings', icon: 'S', label: '設定' },
];

function Sidebar() {
  const location = useLocation();
  const isActive = (path) => location.pathname === path;

  return (
    <div className="sidebar">
      <div className="sidebar-title">民泊管理</div>
      <Nav className="flex-column">
        {navItems.map((item) => (
          <Nav.Link
            key={item.path}
            as={Link}
            to={item.path}
            className={`nav-link ${isActive(item.path) ? 'active' : ''}`}
          >
            <span className="nav-icon">{item.icon}</span>
            <span>{item.label}</span>
          </Nav.Link>
        ))}
      </Nav>
    </div>
  );
}

export default Sidebar;
